import React from "react";
import PropTypes from "prop-types";

const MenuUpIcon = ({
  alt = "Menu Up",
  className = "",
  size = 24,
  onClick = () => {},
}) => (
  <svg
    aria-label={alt}
    className={`wink-icon ${className}`}
    width={size}
    height={size}
    onClick={onClick}
    viewBox="0 0 24 24"
    aria-labelledby="MenuUpIcon"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="MenuUpIcon">{alt}</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 8.586l5.707 5.707-1.414 1.414L12 11.414l-4.293 4.293-1.414-1.414L12 8.586z"
    />
  </svg>
);

MenuUpIcon.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.number,
  onClick: PropTypes.func,
};

export default MenuUpIcon;
